import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { COMMON_PROPERTY } from '../../store/property/common/commonProperty.reducer';
import { Button, Col, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ValidationForm, TextInput, SelectGroup } from 'react-bootstrap4-form-validation';
import { useDispatch } from 'react-redux';
import { PROPERTY_MASTER } from '../../store/propertyMaster/propertyMaster.reducer';
import { FEEDBACK_MODAL_CLOSE, PROPERTY_MODAL_OPEN } from '../../store/actions';
import { createCommonFeedback, createCommonFeedbackForm } from '../../store/property/common/commonProperty.actions';
import { COMMON_FEEDBACK_USERFORM_RESET } from '../../store/property/common/commonProperty.actionsType';
import { fetchFeedbackDataFromProperty } from '../../store/feedbackDetails/feedbackDetails.action';
import { FEEDBACK_DETAILS } from '../../store/feedbackDetails/feedbackDetails.reducer';
import CommonPropertyModal from './CommonPropertyModal';

let apiCallId;

const feedBackModalProperty = 'feedbackModalProperty';

const CommonFeedbackModal = (props) => {
    const [openModal, setOpenModal] = useState(false);
    let [selectedList, setSelectedList] = useState('');
    let dispatch = useDispatch();
    const reset = useRef();

    let { isFeedbackModal, buttonStatus, componentId, propertyComponentId } = useSelector((state) => {
        return state.able;
    });
    let { loading, feedbackType, feedbackStatus } = useSelector((state) => {
        return state[FEEDBACK_DETAILS];
    });
    let { commonFeedbackform } = useSelector((state) => {
        return state[COMMON_PROPERTY];
    });
    let { ipAddressInfo } = useSelector((state) => {
        return state[PROPERTY_MASTER];
    });

    useEffect(() => {
        isFeedbackModal && dispatch(fetchFeedbackDataFromProperty(51)); // Feedback Type
        isFeedbackModal && dispatch(fetchFeedbackDataFromProperty(50)); // Feedback status
        if (componentId === props.id) {
            setOpenModal(isFeedbackModal);
        }
    }, [isFeedbackModal]);

    useEffect(() => {
        if (componentId === props.id) {
            setOpenModal(isFeedbackModal);
        }
    }, []);

    let handleCommonFeedbackChange = (event) => {
        let key = event.target.name;
        let value = event.target.value;
        dispatch(createCommonFeedbackForm(key, value));
    };

    const handleCommonFeedbackSubmit = async (e, formData, inputs) => {
        e.preventDefault();
        let resetRef = reset.current;
        let button = e?.nativeEvent?.submitter?.name;
        if (button === 'Create') {
            formData['ipv4'] = ipAddressInfo?.IPv4 ?? null;
            formData['fldFKStatus'] = feedbackStatus.length > 0 && feedbackStatus.filter((x) => x.fldDescription === 'Pending')[0]['fldId'];
            formData['fldControllerName'] = '';
            formData['fldActionMethod'] = '';
            await dispatch(createCommonFeedback(formData, true, props.id));
            resetRef.resetValidationState(true);
        }
        if (button === 'addNew') {
            formData['ipv4'] = ipAddressInfo?.IPv4 ?? null;
            formData['fldFKStatus'] = feedbackStatus.length > 0 && feedbackStatus.filter((x) => x.fldDescription === 'Pending')[0]['fldId'];
            formData['fldControllerName'] = '';
            formData['fldActionMethod'] = '';
            await dispatch(createCommonFeedback(formData, false, props.id));
            resetRef.resetValidationState(true);
        }
    };

    const handleErrorSubmit = (e, formData, errorInputs) => {
        //console.log(errorInputs);
    };

    const propertyModal = (status) => {
        dispatch({ type: PROPERTY_MODAL_OPEN, id: feedBackModalProperty });
        switch (status) {
            case 'feedbackType':
                setSelectedList('feedbackType');
                apiCallId = 51;
                break;
            default:
                break;
        }
    };

    return (
        <>
            <CommonPropertyModal
                apiCall={fetchFeedbackDataFromProperty(apiCallId)}
                apiCallId={apiCallId}
                id={feedBackModalProperty}
                itemList={selectedList === 'feedbackType' ? feedbackType : []}
            />
            <Modal
                scrollable={true}
                centered
                show={openModal}
                onHide={() => {
                    dispatch({ type: FEEDBACK_MODAL_CLOSE, id: props.id });
                    dispatch({ type: COMMON_FEEDBACK_USERFORM_RESET });
                }}
                backdrop="static"
                id={props?.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title as="h5">Create Feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ValidationForm ref={reset} onSubmit={handleCommonFeedbackSubmit} onErrorSubmit={handleErrorSubmit}>
                        <Form.Row>
                            <Form.Group as={Col} md="12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <Form.Label htmlFor="fldFKType">
                                        Type<span className="text-danger">*</span>
                                    </Form.Label>
                                    {!loading && (
                                        <OverlayTrigger
                                            className="tooltip"
                                            delay={{ hide: 450, show: 300 }}
                                            overlay={(props) => <Tooltip {...props}>Add Feedback Type</Tooltip>}
                                            placement="bottom"
                                        >
                                            <i
                                                onClick={() => propertyModal('feedbackType')}
                                                style={{ color: 'purple', cursor: 'pointer' }}
                                                className="feather icon-plus-circle font-weight-bold"
                                            />
                                        </OverlayTrigger>
                                    )}
                                </div>

                                <SelectGroup
                                    name="fldFKType"
                                    id="fldFKType"
                                    value={commonFeedbackform.fldFKType}
                                    // disabled={buttonStatus === 'delete' && true}
                                    required
                                    errorMessage="Please select a Feedback type."
                                    // onClick={() => {
                                    //     dispatch(fetchFeedbackDataFromProperty(50)); // Feedback status
                                    //     dispatch(fetchFeedbackDataFromProperty(51)); // Feedback type
                                    // }}
                                    onChange={handleCommonFeedbackChange}
                                >
                                    <option value="">Please select</option>
                                    {feedbackType.length > 0 &&
                                        feedbackType.map((item) => {
                                            return (
                                                <option value={item.fldId} key={item.fldId}>
                                                    {item.fldDescription}
                                                </option>
                                            );
                                        })}
                                </SelectGroup>
                            </Form.Group>
                            <Form.Group as={Col} md="12">
                                <Form.Label htmlFor="fldDescription">
                                    Description<span className="text-danger">*</span>
                                </Form.Label>
                                <TextInput
                                    multiline
                                    rows="2"
                                    name="fldDescription"
                                    id="fldDescription"
                                    placeholder="Description"
                                    pattern="^[A-Za-z0-9 ]+$"
                                    errorMessage={{
                                        pattern: 'No special characters are allowed'
                                    }}
                                    // disabled={buttonStatus === 'delete' && true}
                                    required
                                    value={commonFeedbackform.fldDescription}
                                    onChange={handleCommonFeedbackChange}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={12} className="d-flex justify-content-around">
                                <Button
                                    onClick={() => {
                                        dispatch({ type: FEEDBACK_MODAL_CLOSE, id: props.id });
                                        dispatch({ type: COMMON_FEEDBACK_USERFORM_RESET });
                                    }}
                                    variant="secondary"
                                    size="sm"
                                >
                                    Close
                                </Button>
                                <Button type="submit" variant="primary" name="addNew" value="addNew" size="sm">
                                    Save & Add New
                                </Button>
                                <Button variant="info" type="submit" name="Create" value="Create" size="sm">
                                    Save & Close
                                </Button>
                            </Form.Group>
                        </Form.Row>
                    </ValidationForm>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CommonFeedbackModal;
